import { render, staticRenderFns } from "./addTicketCate.vue?vue&type=template&id=77a4540c&scoped=true&"
import script from "./addTicketCate.vue?vue&type=script&lang=js&"
export * from "./addTicketCate.vue?vue&type=script&lang=js&"
import style0 from "./addTicketCate.vue?vue&type=style&index=0&id=77a4540c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a4540c",
  null
  
)

export default component.exports